<!--title -->
<app-modal-title
  [title]="'common.showFile' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content tw-min-h-[350px]">
  <app-file-controller
    [smallSize]="true"
    [fileSrc]="fileUrl"
    [socialMediaFile]="mediaId"
    [type]="fileTypes"
    (resultReady)="fileUrl = $event"
    [fileType]="fileTypes"
  >
  </app-file-controller>
</div>
